import { SqButton } from "@/components/squircle-ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { Portal } from "@radix-ui/react-tooltip";
import {
  RiArchiveLine,
  RiEyeOffLine,
  RiInformationLine,
  RiSideBarLine,
} from "@remixicon/react";

interface Props {
  cellText: string;
  onHide: () => void;
  onRightPanelClick: () => void;
}
const MiscellaneousPrimaryCell = ({ cellText, onHide, onRightPanelClick }: Props) => {
  return (
    <div className="flex justify-between min-h-[30px] items-center">
      <div className=" flex gap-2 items-center">
        <RiArchiveLine size={14} color="#9AA3BD" />
        <span className="font-medium text-[12px] leading-5 text-[#02185966] translate-y-[1px]">
          {cellText}
        </span>
        <TooltipProvider delayDuration={100}>
          <Tooltip>
            <TooltipTrigger>
              <RiInformationLine
                size={14}
                color="#9AA3BD"
                className="hidden group-hover/row:block"
              />
            </TooltipTrigger>
            <Portal>
              <TooltipContent
                className="squircle squircle-mask squircle-fill-[black] text-white text-[12px] py-2 px-3 min-w-0 max-w-[240px]"
                align="start"
                side="top"
              >
                This contains ads which are either deleted, archived, or Getcrux is unable to
                process.
              </TooltipContent>
            </Portal>
          </Tooltip>
        </TooltipProvider>
      </div>
      <div className="flex gap-1">
        <SqButton
          variant="outline"
          size={"sm"}
          shadow={"sm"}
          onClick={onRightPanelClick}
          className="h-7 w-7 hidden group-hover/row:flex p-0"
        >
          <RiSideBarLine size={14} color="#9AA3BD" />
        </SqButton>
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <SqButton
                variant="outline"
                size={"sm"}
                shadow={"sm"}
                onClick={onHide}
                className="h-7 w-7 hidden group-hover/row:flex"
              >
                <RiEyeOffLine size={"14"} color="#9AA3BD" />
              </SqButton>
            </TooltipTrigger>
            <Portal>
              <TooltipContent
                className="squircle squircle-mask squircle-fill-[black] text-white text-[12px] py-2 px-3 min-w-0 max-w-[240px]"
                side="top"
                align="start"
                sideOffset={5}
              >
                Hide
              </TooltipContent>
            </Portal>
          </Tooltip>
        </TooltipProvider>
      </div>
    </div>
  );
};

export default MiscellaneousPrimaryCell;
